// Global packages and components

import { TikTokListingItem } from '~/types'
import { Button, Image, InlineLink } from '~/components'
import { getVimeoEmbedUrl } from '~/utils'
import { useState } from 'react'

// Main export
const TikTokLister = ({
  posterImage,
  title,
  productSlug,
  productLister,
  videoLocation,
  vimeoVideoLink,
  tiktokVideoID,
  youtubeVideoID,
}: TikTokListingItem) => {
  const [isPlaying, setIsPlaying] = useState(false)

  const src =
    videoLocation == 'vimeo'
      ? getVimeoEmbedUrl(vimeoVideoLink)
      : videoLocation == 'tiktok'
        ? `https://www.tiktok.com/embed/${tiktokVideoID}`
        : `https://www.youtube.com/embed/${youtubeVideoID}`

  return (
    <div className="flex h-full flex-col">
      <div className="group relative aspect-tiktok w-full lg:overflow-hidden lg:rounded-2xl">
        {!isPlaying && posterImage ? (
          <button
            onClick={() => setIsPlaying(true)}
            className="relative size-full overflow-hidden rounded-2xl focus:outline-none"
          >
            <Image
              image={posterImage}
              className="absolute inset-0 size-full rounded-2xl object-cover"
            />
            <div className="absolute inset-0 left-1/2 top-1/2 flex size-10 -translate-x-4 -translate-y-4 items-center justify-center rounded-full bg-black/40 text-white">
              <span>▶</span>
            </div>
          </button>
        ) : (
          <iframe
            src={src + (posterImage && '&autoplay=1')}
            title={title}
            allow="encrypted-media"
            className="size-full overflow-hidden rounded-2xl"
            allowFullScreen
          ></iframe>
        )}
      </div>
      <div className="my-2 flex flex-1 origin-bottom flex-col items-center justify-center gap-3 rounded-2xl p-4 lg:bg-white">
        <h2 className="mb-0 hidden flex-1 text-center lg:block">{title}</h2>
        <Button
          title={'Buy Now'}
          to={productSlug}
          fullWidth
          style="tealGreen"
        />
        <InlineLink
          to={productLister}
          label="View More"
        />
      </div>
    </div>
  )
}

export default TikTokLister
